// @flow
import * as React from 'react';
import get from 'lodash/get';
import { compose } from 'redux';
import type { Dispatch } from 'redux';
import type { intlShape } from 'react-intl';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { setSearchParams } from '../../../../Serp/actions';
import {
  searchParametersState,
  existsGeolocationParam as existsGeolocationParamSelector,
  existsWhatParam as existsWhatParamSelector,
} from '../../../../Serp/selectors';
import { getSeoLinksByType } from '../../../../Index/selectors';
import DisambiguationList from '.';
import { trackEvent } from '../../../../tracking/actions';
import {
  disambiguationListImpressionEvent,
  disambiguationListClickEvent,
  disambiguationListNoImpressionEvent,
} from '../../../../tracking/events';
import { activateUserFilterInteraction } from '../../../../Serp/components/Filters/shared/actions';

type MapDispatchToProps = {
  onOptionSelect: Function,
  trackEvent: Function, // Test AB [PROD-283] - Disambiaguation tracking
};

type MapStateToProps = {
  isShowed: boolean,
  what: ?string,
  where: ?string,
};

type State = {
  showAllItems: boolean,
};

type Props = {
  allItems: Array<Object>,
  searchParameters: Object,
  isShowed: boolean,
  what: ?string,
  where: ?string,
  intl: intlShape,
  onOptionSelect: Function,
  trackEvent: Function, // Test AB [PROD-283] - Disambiaguation tracking
};

type OwnProps = {
  searchParameters: Object,
};

export class InnerComponent extends React.Component<Props, State> {
  static defaultProps = {
    what: null,
    where: null,
  };

  constructor(props: Props): void {
    super(props);

    // $FlowFixMe
    this.handleViewMore = this.handleViewMore.bind(this);
  }

  state = {
    showAllItems: false,
  };

  componentDidMount() {
    if (this.props.isShowed) {
      this.props.trackEvent(disambiguationListImpressionEvent());
    } else {
      this.props.trackEvent(disambiguationListNoImpressionEvent());
    }
  }

  componentWillReceiveProps(nextProps: Props): void {
    const { isShowed, searchParameters: currentSearchParameters } = this.props;
    const { searchParameters: nextSearchParameters } = nextProps;

    const wasSerpPagination =
      get(currentSearchParameters, 'page') !== get(nextSearchParameters, 'page');

    if (isShowed !== nextProps.isShowed || wasSerpPagination) {
      this.setState({
        showAllItems: false,
      });
    }
  }

  handleViewMore(e: SyntheticEvent<HTMLLinkElement>): void {
    this.setState({
      showAllItems: true,
    });
    e.preventDefault();
  }

  render(): React.Node {
    const { showAllItems } = this.state;

    return (
      <DisambiguationList
        {...this.props}
        items={showAllItems ? this.props.allItems : this.props.allItems.slice(0, 2)}
        showAllItems={showAllItems}
        onViewMore={this.handleViewMore}
      />
    );
  }
}

export function mapDispatchToProps(
  dispatch: Dispatch<*>,
  { searchParameters }: OwnProps
): MapDispatchToProps {
  return {
    onOptionSelect(item: Object): void {
      const type = get(item, 'type');
      const key = type === 'where' ? 'where' : 'what_d';
      const value = get(item, type);
      const whatAccented = type === 'where' ? get(searchParameters, 'whatAccented') || '' : value;
      const newSearchParams = {
        ...searchParameters,
        [key]: value,
        whatAccented,
        isSeoUrl: false,
        isSemUrl: false,
        routeName: 'serp_search',
        pageName: 'serp',
        page: 1,
      };

      // Test AB [PROD-283] - Disambiaguation tracking
      dispatch(trackEvent(disambiguationListClickEvent()));

      dispatch(activateUserFilterInteraction());
      dispatch(setSearchParams(newSearchParams, false));
    },
    // Test AB [PROD-283] - Disambiaguation tracking
    trackEvent: event => dispatch(trackEvent(event)),
  };
}

export function mapStateToProps(state: Object): MapStateToProps {
  const searchParams = searchParametersState(state);
  const existsWhatParam = existsWhatParamSelector(state);
  const existsGeolocationParam = existsGeolocationParamSelector(state);

  return {
    what: get(searchParams, 'what_d'),
    where: get(searchParams, 'where'),
    isShowed:
      (!existsWhatParam || !existsGeolocationParam) &&
      (Boolean(get(searchParams, 'what_d')) || Boolean(get(searchParams, 'where'))),
    allItems: getSeoLinksByType(state),
  };
}

const DisambiguationListContainer = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(InnerComponent);

DisambiguationListContainer.displayName = 'DisambiguationListContainer';

export default DisambiguationListContainer;



// WEBPACK FOOTER //
// ./app/common/Lists/DisambiguationList/list/container.js